﻿(function () {
    "use strict";

    angular
        .module("app")
        .component("projectItemsSummary", {
            bindings: {
                id: "@?",
                modalTarget: "@",
                project: "=",
                form: "=",
            },
            templateUrl: ['version', function (version) {
                return `/js/components/projects/itemsSummary.html?v=${version}`
            }],
            controller: ItemsSummaryController,
            controllerAs: "vm"
        });

    ItemsSummaryController.$inject = ["$scope", "$rootScope", "$element", "request"];

    function ItemsSummaryController($scope, $rootScope, $element, request) {
        var vm = this;

        vm.filters = {
            notReviewed: true,
            reviewed: true,
            invoiced: true,
            workareaIds: [],
            visitIds: []
        };

        vm.analyzeAreas = {};
        vm.analyzeVisits = {};

        vm.$onInit = onInit;
        vm.print = print;
        vm.$popup = $();

        function onInit() {
            vm.id = vm.id || "items-summary-popup-" + $scope.$id;
            vm.groups = [];

            $(vm.modalTarget).on('click', showModal);
        }

        function showModal() {
            if (!vm.project)
                return;

            var typeNames = { 1: 'projects', 2: 'tickets', 3: 'maintenance' }

            vm.exportUrl = '/' + vm.project.url + '/items-summary-report/upload';

            if (vm.exportUrl.indexOf('/' + typeNames[vm.project.type]) == -1)
                vm.exportUrl = '/' + typeNames[vm.project.type].concat(vm.exportUrl);

            vm.$popup = $($element).find("#" + vm.id);

            vm.$popup.modal();
        }

        function print() {
            var data = (vm.newFilters) || {
                projectId: vm.project.id,
                workareaIds: vm.filters.workareaIds,
                visitIds: vm.filters.visitIds,
                notReviewed: vm.filters.notReviewed,
                reviewed: vm.filters.reviewed,
                invoiced: vm.filters.invoiced
            }

            request.post($rootScope.apiEndpoint + '/projecttickets' + vm.exportUrl, data)
                .then(function (response) {
                    window.open(response.data.url, "_blank");

                }, function (e) {
                    console.log(e);
                    alert("There was an error printing.");
                });
        }

        vm.onFilterChange = filter => vm.newFilters = filter

        vm.onHasItems = hasItems => { 
            vm.hasItems = hasItems;
            setTimeout(() => $scope.$apply(), 1)
        };
    }
})();
